// extracted by mini-css-extract-plugin
export default {"root":"kbzsWP","vertical":"ezfUwI","horizontal":"YWdGql","bw":"vuvzkc","inset":"EmIXZZ"};